import Header from "../components/header";

function PrivacyPolicy(){
    const navigateToLoginPage = () => {
        window.location.href = '/signup';
    }

    return <>
    <Header URLForLogo='/' CTA='Sign up' functionForButton={navigateToLoginPage}></Header>
    <div className="privacy" style={{width:"90%",margin:"auto",textAlign:"left"}}>
    <h1>Privacy Policy</h1>

<p>This Privacy Policy applies between you, the User of this Website, and Mako Digital Ltd, the owner and provider of this Website. Mako Digital Ltd takes the privacy of your information very seriously. This Privacy Policy applies to our use of any and all Data collected by us or provided by you in relation to your use of the Website.</p>

<p><strong>Please read this Privacy Policy carefully.</strong></p>

<h2>Definitions and Interpretation</h2>

<p>In this Privacy Policy:</p>
<p><strong>Data</strong>: all information you submit to Mako Digital Ltd via the Website.</p>
<p><strong>Cookies</strong>: small text files placed on your computer by this Website.</p>
<p><strong>Data Protection Laws</strong>: applicable law relating to the processing of personal data including GDPR.</p>
<p><strong>GDPR</strong>: UK General Data Protection Regulation.</p>
<p><strong>Mako Digital Ltd / we / us</strong>: Mako Digital Ltd, registered in England and Wales (No. 16476959), with registered office at 20 Wenlock Road, London, N1 7GU.</p>
<p><strong>UK and EU Cookie Law</strong>: Privacy and Electronic Communications Regulations.</p>
<p><strong>User / you</strong>: any third party accessing the Website not employed by or contracted with Mako Digital Ltd.</p>
<p><strong>Website</strong>: https://www.mako-app.com/ and its sub-domains.</p>

<h2>Scope of this Privacy Policy</h2>

<p>This Privacy Policy applies only to the actions of Mako Digital Ltd and Users with respect to this Website. It does not extend to other websites accessible via this Website.</p>
<p>Mako Digital Ltd is the "data controller".</p>

<h2>Data Collected</h2>

<p>We may collect the following Data:</p>
<p>- Name</p>
<p>- Contact information (email, phone)</p>
<p>- Financial information (card numbers)</p>

<h2>How We Collect Data</h2>

<p>We collect Data in the following ways:</p>
<p>- Data is given to us by you</p>
<p>- Data is collected automatically</p>

<h2>Data That is Given to Us by You</h2>

<p>We collect your Data when you:</p>
<p>- Contact us (via website, phone, email, etc.)</p>
<p>- Register with us for services</p>
<p>- Make payments</p>

<h2>Data That is Collected Automatically</h2>

<p>- We collect information such as IP address, access times, and interactions with content.</p>
<p>- We use cookies. See "Cookies" section for more information.</p>

<h2>Our Use of Data</h2>

<p>We use Data to:</p>
<p>- Keep internal records</p>
<p>- Improve products/services</p>
<p>- Send marketing emails (with consent)</p>

<p>We may use your Data for our legitimate interests. You have rights (see "Your Rights").</p>

<h2>Who We Share Data With</h2>

<p>We may share Data with:</p>
<p>- Employees, agents, advisors (to support customers)</p>
<p>- Third-party service providers (for analytics, errors)</p>
<p>- Payment processors</p>

<h2>Keeping Data Secure</h2>

<p>- Account access is password protected</p>
<p>- Data is stored on secure servers</p>
<p>- Payments are encrypted (SSL)</p>
<p>- Suspected breaches should be reported to hello@mako-app.com</p>

<h2>Data Retention</h2>

<p>We retain your Data only as long as necessary.</p>
<p>Deleted Data may persist in backups for legal or tax purposes.</p>

<h2>Your Rights</h2>

<p>You have the right to:</p>
<p>- Access your Data</p>
<p>- Correct inaccuracies</p>
<p>- Request erasure</p>
<p>- Restrict or object to use</p>
<p>- Request portability of Data</p>

<p>Contact: hello@mako-app.com</p>
<p>Complaints can be referred to the ICO (https://ico.org.uk/)</p>

<h2>Transfers Outside the UK and EEA</h2>

<p>We may transfer Data outside the UK/EEA where adequate safeguards exist.</p>

<h2>Links to Other Websites</h2>

<p>We are not responsible for other websites linked from this Website. Review their privacy policies before use.</p>

<h2>Changes of Business Ownership and Control</h2>

<p>Data may be transferred to new business owners.</p>

<h2>Cookies</h2>

<p>We use cookies to improve the Website experience. Consent is required to use cookies.</p>

<h3>Types of Cookies Used:</h3>

<p><strong>Strictly necessary cookies</strong>: Required for basic website functionality.</p>
<p><strong>Analytical/performance cookies</strong>: Used to analyze visitor behavior and improve performance.</p>
<p><strong>Functionality cookies</strong>: Remember preferences and personalize the experience.</p>

<p>You may disable cookies in your browser. Visit aboutcookies.org for more info.</p>

<h2>General</h2>

<p>- You may not transfer your rights under this policy.</p>
<p>- Invalid provisions will be removed without affecting the rest.</p>
<p>- This Privacy Policy is governed by English law.</p>

<h2>Changes to This Privacy Policy</h2>

<p>Mako Digital Ltd may update this Privacy Policy. Continued use of the Website means you accept the changes.</p>
<p>Contact: hello@mako-app.com</p>
<p><strong>Created on:</strong> 11 July 2025</p>
</div>
    </>
}
    
export default PrivacyPolicy;